<template>
  <div class="create-edit-receiptProduction-modal petit-nature-modal">
    <div class="header">
      <h1 class="subtitle is-4" v-if="isCreateReceiptProduction">
        Nova produção
      </h1>
      <h1 class="subtitle is-4" v-else>Editar produção</h1>
      <span class="close-button" @click="$emit('close')">
        <i class="mdi mdi-window-close"></i>
      </span>
    </div>
    <form
      action=""
      class="body"
      novalidate
      @submit.prevent="validateBeforeSubmit"
    >
      <div class="columns is-multiline is-variable">
        <div class="column is-12">
          <label class="label">Selecione a receita</label>
          <b-field>
            <b-autocomplete
              v-model="receiptSearchText"
              :data="receiptList"
              placeholder="Buscar receita"
              field="name"
              :loading="isFetching"
              :keep-first="true"
              @keyup.native="getReceiptAsyncData"
              @select="option => (selectedReceipt = option)"
            >
              <template slot-scope="props">
                <span>{{ props.option.name }}</span>
              </template>
              <template slot="empty">
                Nenhum resultado encontrado
              </template>
            </b-autocomplete>
          </b-field>
        </div>

        <div class="column is-6">
          <b-field label="Data de produção">
            <b-datepicker
              v-model="receiptProduction.manufacturingDate"
              icon="calendar-today"
            >
            </b-datepicker>
          </b-field>
        </div>
        <div class="column is-6">
          <b-field label="Data de validade">
            <b-datepicker
              v-model="receiptProduction.expirationDate"
              icon="calendar-today"
            >
            </b-datepicker>
          </b-field>
        </div>

        <div class="column is-12">
          <label class="label">Selecione o ingrediente</label>
          <b-field>
            <b-autocomplete
              expanded
              v-model="supplySearchText"
              :data="suppliesList"
              placeholder="Buscar Ingrediente"
              field="ingredient.name"
              :loading="isFetching"
              :keep-first="true"
              @keyup.native="getSupplyAsyncData"
              @select="option => (selectedSupply = option)"
            >
              <template slot-scope="props">
                <span>{{ props.option.ingredient.name }}</span>
                <span> - {{ props.option.ingredient.category.name }}</span>
                <span> - {{ props.option.batch }}</span>
              </template>
              <template slot="empty">
                Nenhum resultado encontrado
              </template>
            </b-autocomplete>
            <p class="control">
              <a class="button is-primary" @click="addSupplyToList">+</a>
            </p>
          </b-field>
        </div>

        <div class="column is-12 " v-if="receiptProduction.supplies.length">
          <div class="supplies-table">
            <table class="table is-fullwidth ">
              <thead>
                <tr>
                  <th>Nome</th>
                  <th>Categoria</th>
                  <th>Lote</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(supply, index) in receiptProduction.supplies"
                  v-bind:key="supply.id"
                >
                  <td>{{ supply.ingredient.name }}</td>
                  <td>{{ supply.ingredient.category.name }}</td>
                  <td>{{ supply.batch }}</td>
                  <td><a @click="removeSupply(index)">Remover</a></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="column is-12 message-holder" v-else>
          <div class="no-items-message has-text-centered is-centered">
            Nenhum item adicionado à receita.
          </div>
        </div>

        <div class="column is-12" v-if="packingsToSelect.length">
          <label class="label">Quantidade produzida</label>
          <div class="columns is-multiline is-variable packing-list-holder">
            <div
              class="column is-5"
              v-for="pack in packingsToSelect"
              :key="pack.id"
            >
              <b-field expanded>
                <b-input v-model="pack.quantity" type="number" />
                <p class="control">
                  <a class="button is-primary">{{ pack.size | packingSize }}</a>
                </p>
              </b-field>
            </div>
          </div>
        </div>
        <div class="column is-12 message-holder" v-else>
          <div class="no-items-message has-text-centered is-centered">
            Nenhuma embalagem foi encontrada.
          </div>
        </div>
        <div class="footer column is-12 has-text-right">
          <button
            type="submit"
            class="button is-medium primary"
            :class="{ 'is-loading': isPendingAction }"
            :disabled="isPendingAction || !selectedReceipt.name"
          >
            <span v-if="isCreateReceiptProduction">Adicionar</span>
            <span v-else>Salvar</span>
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import NotificationsWrapper from "../../helpers/NotificationsWrapper";
import utils from "../../helpers/debounce";
import QueryBuilder from "../../helpers/QueryBuilder";
import ReceiptService from "../../services/ReceiptService";
import SupplyService from "../../services/SupplyService";
export default {
  name: "CreateEditReceiptProductionModal",
  data: () => ({
    isCreateReceiptProduction: true,
    isPendingAction: false,
    receiptProduction: {},
    receiptSearchText: "",
    receiptList: [],
    isFetching: false,
    selectedReceipt: {},
    supplySearchText: "",
    suppliesList: [],
    selectedSupply: {}
  }),
  computed: {
    ...mapState({ packings: state => state.packing.packings })
  },
  methods: {
    addSupplyToList() {
      let alreadyInserted =
        this.receiptProduction.supplies.filter(
          supp => supp.id === this.selectedSupply.id
        ).length > 0;
      if (!alreadyInserted && this.selectedSupply.id) {
        this.receiptProduction.supplies.push(this.selectedSupply);
      }
    },
    removeSupply(index) {
      this.receiptProduction.supplies = this.receiptProduction.supplies.filter(
        (item, i) => {
          return i !== index;
        }
      );
    },
    getSupplyAsyncData: utils.debounce(function() {
      this.suppliesList = [];
      let query = {
        batch: this.supplySearchText,
        size: 5
      };
      query = QueryBuilder.getQueryString(query);
      this.isFetching = true;
      query += "&sort=purchaseDate,desc"
      SupplyService.getSupplies(query)
        .then(({ data }) => {
          this.suppliesList = data.content;
        })
        .finally(() => (this.isFetching = false));
    }, 300),
    getReceiptAsyncData: utils.debounce(function() {
      this.receiptList = [];
      let query = {
        name: this.receiptSearchText,
        size: 5
      };
      query = QueryBuilder.getQueryString(query);
      this.isFetching = true;
      ReceiptService.getReceipts(query)
        .then(({ data }) => {
          this.receiptList = data.content;
        })
        .finally(() => (this.isFetching = false));
    }, 300),
    ...mapActions({
      createReceiptProduction: "receiptProduction/createReceiptProduction",
      editReceiptProduction: "receiptProduction/editReceiptProduction"
    }),
    getPackedProductsArray() {
      let packedProducts = [];
      this.packings.forEach(pack => {
        let qnt = parseInt(pack.quantity) || 0;
        packedProducts.push({
          quantity: qnt,
          packing: { id: pack.id, size: pack.size }
        });

      });
      return packedProducts;
    },
    validateBeforeSubmit() {
      this.receiptProduction.receipt = this.selectedReceipt;
      if(this.isCreateReceiptProduction) {
        this.receiptProduction.packedProducts = this.getPackedProductsArray();
      } else {
        this.receiptProduction.packedProducts.forEach(pp => {
          this.packingsToSelect.forEach(ps => {
            if(pp.packing.id === ps.id) {
              pp.quantity = parseInt(ps.quantity) || 0
            }
          })
        })
      }

      if (this.isCreateReceiptProduction) {
        this.createReceiptProduction(this.receiptProduction)
          .then(() => {
            NotificationsWrapper.success("Produção cadastrada com sucesso!");
            this.$emit("close");
          })
          .catch(error => {
            let errorCode = { error }.error.response.status;

            switch (errorCode) {
              default:
                NotificationsWrapper.error(
                  "Não foi possível inserir a produção. Verifique os dados e tente novamente."
                );
                break;
            }
          })
          .finally(() => (this.isPendingAction = false));
      } else {
        this.editReceiptProduction(this.receiptProduction)
          .then(() => {
            NotificationsWrapper.success("Produção atualizada com sucesso!");
            this.$emit("close");
          })
          .catch(error => {
            let errorCode = { error }.error.response.status;

            switch (errorCode) {
              default:
                NotificationsWrapper.error(
                  "Não foi possível atualizar a produção. Tente novamente."
                );
                break;
            }
          })
          .finally(() => (this.isPendingAction = false));
      }
    }
  },
  props: {
    receiptProductionParam: {}
  },
  created() {
    if (!this.receiptProductionParam.id) {
      this.isCreateReceiptProduction = true;
      this.receiptProduction = {
        receipt: {},
        expirationDate: new Date(),
        manufacturingDate: new Date(),
        supplies: [],
        packedProducts: []
      };
      this.packingsToSelect = this.packings.map(p => {
        p.quantity = 0;
        return p;
      });
    } else {
      this.isCreateReceiptProduction = false;
      this.receiptProduction = this.receiptProductionParam;
      this.receiptProduction.expirationDate = new Date(
        this.receiptProduction.expirationDate
      );
      this.receiptProduction.manufacturingDate = new Date(
        this.receiptProduction.manufacturingDate
      );
      this.selectedReceipt = this.receiptProduction.receipt;
      this.receiptSearchText = this.receiptProduction.receipt.name;

      this.suppliesList = this.receiptProduction.supplies;

      this.packings.forEach(pack => {
        pack.quantity = 0;
        this.receiptProduction.packedProducts.forEach(pp => {
          if (pack.id === pp.packing.id) {
            pack.quantity = pp.quantity > 0 ? pp.quantity : 0;
          }
        });
      });
      this.packingsToSelect = this.packings;
    }
  }
};
</script>

<style lang="scss" scoped>
  .supplies-table{
    overflow: auto;
    max-height: 300px;
  }
</style>
